if (typeof location === 'object' && location.hostname === 'www.jogitanacs.info') {
    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
    
    ga('create', 'UA-36353861-1', 'auto');
} else if (typeof window === 'object') {
    window.ga = (...args) => {
        ga.arr = ga.arr || [];
        ga.arr.push(args);
    };
}

export const pageview = (url) => {
    window.ga('send', 'pageview', url);
};

export const clickevent = (category, action, label, value) => {
    window.ga('send', 'event', category, action, label, value);
};

// window.dataLayer = window.dataLayer || [];
// function gtag(){dataLayer.push(arguments);}
// gtag('js', new Date());

// export const pageview = (title) => {
//     if (location.hostname !== 'www.jogitanacs.info') {
//         return;
//     }
    
//     gtag('config', 'UA-36353861-1', {
//         'page_title': title,
//         'page_location': location.href,
//         'page_path': location.pathname
//       });
// };



// WEBPACK FOOTER //
// ./src/client/tracking.js